import moment from 'moment-timezone';
import { Option } from '../../../general-types';
import { getTimezoneLabel } from './getTimezoneLabel';

let cachedOptions: Option<string, string>[] | null = null;

/**
 * US timezones only
 * Caches result for performance
 */
export const getTimezoneOptions = (): Option<string, string>[] => {
  if (cachedOptions) return cachedOptions;

  const usZones = moment.tz.zonesForCountry('US') || [];

  cachedOptions = usZones.map((tz) => ({
    value: tz,
    label: getTimezoneLabel(tz),
  }));

  return cachedOptions;
};
